(function( $ ) {

	if ($("#pip-player").length > 0) {
		if (Cookies.get('teaserpipvideo') == undefined) {
			var tag = document.createElement('script');
			if ($(".teaserpip").data('type') == 'vimeo') {
				tag.src = "https://player.vimeo.com/api/player.js";
				tag.onload = function () {
					pipOnVimeoAPIReady();
				};
			} else {
				tag.src = "https://www.youtube.com/iframe_api";
			}
			var firstScriptTag = document.getElementsByTagName('script')[0];
			firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
		} else {
			$(".pip").remove();
		}

		$(".pip-actions .btn_full_screen").click(function (e) {
			e.preventDefault();
			$(".pip").addClass("fullscreen");
		});

		$(".pip .btn_fullscreen").click(function (e) {
			e.preventDefault();
			$(".pip").removeClass("fullscreen");
		});
	}

	 /**
	 * If we are using a Vimeo video, this function will take care of instantiate the player
	 */
	function pipOnVimeoAPIReady() {
		var pipPlayerVimeo = new Vimeo.Player('pip-player', {
			'byline': false,
			'title': false,
			'background': true,
			'dnt': true,
			'controls': false
		});

		pipPlayerVimeo.ready().then(function () {
			pipPlayerVimeo.setVolume(0);
			pipPlayerVimeo.setLoop(true);
			pipPlayerVimeo.play();
			$(".pip").addClass("show");
		});

		$(".pip-actions .btn_close").click(function (e) {
			e.preventDefault();
			pipPlayerVimeo.unload().then(function() {
				$(".pip").remove();
				if ($(".teaserpip").data('cookie') == 'on') {
					Cookies.set('teaserpipvideo', '1', {
						path: ''
					});
				}
			});
		});

		$(".pip-actions .btn_mute_unmute").click(function (e) {
			e.preventDefault();
			var $this = this;

			if ($(".teaserpip").data('muted') == 'on') {
				$(".teaserpip").data('muted', 'off');
				$($this).addClass("unmute");
				pipPlayerVimeo.setVolume(1);
			} else {
				$(".teaserpip").data('muted', 'on');
				$($this).removeClass("unmute");
				pipPlayerVimeo.setVolume(0);
			}
		});

		$(".pip-actions .btn_play_pause").click(function (e) {
			e.preventDefault();
			pipPlayerVimeo.getPaused().then(function(paused) {
				if(paused){
					pipPlayerVimeo.play();
					$(".pip-actions .btn_play_pause").removeClass("play");
				} else {
					pipPlayerVimeo.pause();
					$(".pip-actions .btn_play_pause").addClass("play");
				}
			});
		});
	}

	var pipPlayerYouTube;
	window.onYouTubeIframeAPIReady = function() {
		var pipVideoID = $("#pip-player").data('videourl');

		pipPlayerYouTube = new YT.Player("pip-player", {
			videoId: pipVideoID,
			host: 'http://www.youtube-nocookie.com',
			events: {
				'onReady': onPlayerReady,
				'onStateChange': onPlayerStateChange
			},
			playerVars: {
				autoplay: 0,
				playlist: pipVideoID,
				modestbranding: 1,
				rel: 0,
				disablekb: 0,
				fs: 0,
				loop: 1,
				showinfo: 0
			}
		});

		$(".pip-actions .btn_close").click(function (e) {
			e.preventDefault();
			pipPlayerYouTube.stopVideo();
			pipPlayerYouTube.clearVideo();
			$(".pip").remove();
			if ($(".teaserpip").data('cookie') == 'on') {
				Cookies.set('teaserpipvideo', '1', {
					path: ''
				});
			}
		});

		$(".pip-actions .btn_mute_unmute").click(function (e) {
			e.preventDefault();
			
			if ($(".teaserpip").data('muted') == 'on') {
				$(this).addClass("unmute");
				$(".teaserpip").data('muted', 'off');
				pipPlayerYouTube.unMute();
			} else {
				$(this).removeClass("unmute");
				$(".teaserpip").data('muted', 'on');
				pipPlayerYouTube.mute();
			}
		});

		$(".pip-actions .btn_play_pause").click(function (e) {
			e.preventDefault();
			if (pipPlayerYouTube.getPlayerState() == 2) {
				pipPlayerYouTube.playVideo();
			} else {
				pipPlayerYouTube.pauseVideo();
			}
		});
	}

	function onPlayerReady(event) {
		event.target.mute();
		event.target.playVideo();
		$(".pip").addClass("show");
	}

	function onPlayerStateChange(event) {
		if (event.data === YT.PlayerState.PAUSED) {
			$(".pip-actions .btn_play_pause").addClass("play");
		} else if (event.data === YT.PlayerState.PLAYING) {
			$(".pip-actions .btn_play_pause").removeClass("play");
		}
	}

})( jQuery );
